import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import useBroker from '@/hooks/useBroker';
import hasItems from '@/lib/utils/hasItems';

import ExportPartyModal from '../components/ExportPartyModal/ExportPartyModal';
import isPartyInCrm from '../utils/isPartyInCrm';

import useCreateTask from './useCreateTask';
import useExportEmail from './useExportEmail';
import useExportParty from './useExportParty';

export default function useCrm() {
  const { showModal } = useModal();
  const { crms } = useBroker();

  const party = useSelectedParty();

  const partyCrms = crms?.filter((crm) => isPartyInCrm(party, crm.key));
  const missingCrms =
    crms?.filter((crm) => !isPartyInCrm(party, crm.key)) ?? [];

  const { exportParty } = useExportParty();
  const { canExportEmail, exportEmail } = useExportEmail();
  const { canCreateTask, createTask } = useCreateTask();

  const exportPartyToMissingCrms = () => {
    if (!party) return;

    showModal(ExportPartyModal, {
      partyId: party.id,
      crms: missingCrms,
      titleKey: 'EXPORT_PARTY_TITLE',
    });
  };

  return {
    distributionCrms: crms,
    availableCrms: partyCrms,
    exportParty,
    canExportEmail,
    exportEmail,
    canCreateTask,
    createTask,
    canExportPartyToMissingCrms: hasItems(missingCrms),
    exportPartyToMissingCrms,
  };
}
